import * as R from 'ramda'
import {
  Exceptions,
  GET_USERS,
  OPEN_USER_PROFILE,
  GetUsersAPI,
  OpenUserProfileAPI,
  User,
} from '@weblite-wapps/protocol'
import { wappSubscription } from '../helper/subscription-handler'
import { getUser } from '$logic/users'
import { getImageUrl } from '$func/imageUrl'
import { normalizeListByKey } from '$func/utils'
import { openUserProfile } from '$logic/router'

wappSubscription.subscribe<GetUsersAPI>(GET_USERS, async ({ ids }) => {
  const users = await Promise.all(
    ids.map(async id => {
      const user: User = await getUser(id)
      if (!user) return null

      return {
        ...R.pick(
          [
            'id',
            'phone',
            'username',
            'firstname',
            'lastname',
            'bio',
            'status',
            'isDeleted',
          ],
          user,
        ),
        image: getImageUrl(user.image),
      }
    }),
  )
  return { users: normalizeListByKey('id', users.filter(Boolean)) }
})

wappSubscription.subscribe<OpenUserProfileAPI>(
  OPEN_USER_PROFILE,
  async ({ userId }, meta) => {
    const user = await getUser(userId)
    if (!user) return { errorCode: Exceptions.NOT_FOUND }

    await openUserProfile(userId)
    return { status: 'ok' }
  },
)
